module.exports = __webpack_public_path__ + "img/20220207_zones-04.a63d96fd.png";